// Nasal spray products — from Nasal_Spray.xlsx
export const NASAL_SPRAY_PRODUCTS = [
  {
    "id": "pnas001",
    "name": "Sodium Chloride Nasal Spray",
    "generic": "Sodium Chloride",
    "strength": "0.65%, Isotonic",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Isotonic/hypertonic saline nasal spray for nasal hygiene and congestion relief."
  },
  {
    "id": "pnas002",
    "name": "Hypertonic Saline Nasal Spray",
    "generic": "Hypertonic Saline",
    "strength": "2.3%, 3%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Isotonic/hypertonic saline nasal spray for nasal hygiene and congestion relief."
  },
  {
    "id": "pnas003",
    "name": "Sea Water Nasal Spray",
    "generic": "Sea Water",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Isotonic/hypertonic saline nasal spray for nasal hygiene and congestion relief."
  },
  {
    "id": "pnas004",
    "name": "Oxymetazoline HCl Nasal Spray",
    "generic": "Oxymetazoline HCl",
    "strength": "0.025%, 0.05%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical nasal decongestant for short-term relief of nasal congestion."
  },
  {
    "id": "pnas005",
    "name": "Xylometazoline HCl Nasal Spray",
    "generic": "Xylometazoline HCl",
    "strength": "0.05%, 0.1%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical nasal decongestant for short-term relief of nasal congestion."
  },
  {
    "id": "pnas006",
    "name": "Phenylephrine HCl Nasal Spray",
    "generic": "Phenylephrine HCl",
    "strength": "0.25%, 0.5%, 1%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical nasal decongestant for short-term relief of nasal congestion."
  },
  {
    "id": "pnas007",
    "name": "Naphazoline Nasal Spray",
    "generic": "Naphazoline",
    "strength": "0.05%, 0.1%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical nasal decongestant for short-term relief of nasal congestion."
  },
  {
    "id": "pnas008",
    "name": "Tramazoline Nasal Spray",
    "generic": "Tramazoline",
    "strength": "0.118%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical nasal decongestant for short-term relief of nasal congestion."
  },
  {
    "id": "pnas009",
    "name": "Fluticasone Propionate Nasal Spray",
    "generic": "Fluticasone Propionate",
    "strength": "50 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas010",
    "name": "Fluticasone Furoate Nasal Spray",
    "generic": "Fluticasone Furoate",
    "strength": "27.5 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas011",
    "name": "Mometasone Furoate Nasal Spray",
    "generic": "Mometasone Furoate",
    "strength": "50 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas012",
    "name": "Budesonide Nasal Spray",
    "generic": "Budesonide",
    "strength": "64 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas013",
    "name": "Beclometasone Dipropionate Nasal Spray",
    "generic": "Beclometasone Dipropionate",
    "strength": "50 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas014",
    "name": "Triamcinolone Acetonide Nasal Spray",
    "generic": "Triamcinolone Acetonide",
    "strength": "55 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas015",
    "name": "Ciclesonide Nasal Spray",
    "generic": "Ciclesonide",
    "strength": "37 mcg, 50 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas016",
    "name": "Dexamethasone Sodium Phosphate Nasal Spray",
    "generic": "Dexamethasone Sodium Phosphate",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal corticosteroid for allergic rhinitis and nasal inflammation."
  },
  {
    "id": "pnas017",
    "name": "Azelastine HCl Nasal Spray",
    "generic": "Azelastine HCl",
    "strength": "0.1%, 0.15%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal antihistamine for allergic rhinitis symptom relief."
  },
  {
    "id": "pnas018",
    "name": "Olopatadine HCl Nasal Spray",
    "generic": "Olopatadine HCl",
    "strength": "0.6%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal antihistamine for allergic rhinitis symptom relief."
  },
  {
    "id": "pnas019",
    "name": "Levocabastine Nasal Spray",
    "generic": "Levocabastine",
    "strength": "0.05%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal antihistamine for allergic rhinitis symptom relief."
  },
  {
    "id": "pnas020",
    "name": "Ketotifen Nasal Spray",
    "generic": "Ketotifen",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal antihistamine for allergic rhinitis symptom relief."
  },
  {
    "id": "pnas021",
    "name": "Cromolyn Sodium Nasal Spray",
    "generic": "Cromolyn Sodium",
    "strength": "4%, 5.2 mg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Mast cell stabilizer nasal spray for allergic rhinitis prophylaxis."
  },
  {
    "id": "pnas022",
    "name": "Ipratropium Bromide Nasal Spray",
    "generic": "Ipratropium Bromide",
    "strength": "0.03%, 0.06%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Anticholinergic nasal spray for rhinorrhea control."
  },
  {
    "id": "pnas023",
    "name": "Azelastine + Fluticasone Nasal Spray",
    "generic": "Azelastine + Fluticasone",
    "strength": "137 mcg + 50 mcg",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas024",
    "name": "Olopatadine + Mometasone Nasal Spray",
    "generic": "Olopatadine + Mometasone",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas025",
    "name": "Xylometazoline + Ipratropium Nasal Spray",
    "generic": "Xylometazoline + Ipratropium",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas026",
    "name": "Xylometazoline + Dexpanthenol Nasal Spray",
    "generic": "Xylometazoline + Dexpanthenol",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas027",
    "name": "Oxymetazoline + Menthol Nasal Spray",
    "generic": "Oxymetazoline + Menthol",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas028",
    "name": "Oxymetazoline + Eucalyptus Nasal Spray",
    "generic": "Oxymetazoline + Eucalyptus",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Combination nasal spray for comprehensive allergic rhinitis relief."
  },
  {
    "id": "pnas029",
    "name": "Ketorolac Tromethamine Nasal Spray",
    "generic": "Ketorolac Tromethamine",
    "strength": "15.75 mg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Pain Management",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "NSAID nasal spray for localized anti-inflammatory and analgesic action."
  },
  {
    "id": "pnas030",
    "name": "Diclofenac Nasal Spray",
    "generic": "Diclofenac",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Pain Management",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "NSAID nasal spray for localized anti-inflammatory and analgesic action."
  },
  {
    "id": "pnas031",
    "name": "Calcitonin Salmon Nasal Spray",
    "generic": "Calcitonin Salmon",
    "strength": "200 IU/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Orthopaedics",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal peptide therapy for bone metabolism disorders."
  },
  {
    "id": "pnas032",
    "name": "Desmopressin Nasal Spray",
    "generic": "Desmopressin",
    "strength": "10 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Endocrinology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal hormonal therapy."
  },
  {
    "id": "pnas033",
    "name": "Naloxone HCl Nasal Spray",
    "generic": "Naloxone HCl",
    "strength": "4 mg, 8 mg",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Critical Care",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Emergency-use intranasal formulation for rapid systemic absorption."
  },
  {
    "id": "pnas034",
    "name": "Midazolam Nasal Spray",
    "generic": "Midazolam",
    "strength": "5 mg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Critical Care",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal CNS-acting formulation for emergency/acute use."
  },
  {
    "id": "pnas035",
    "name": "Diazepam Nasal Spray",
    "generic": "Diazepam",
    "strength": "5 mg, 10 mg, 20 mg",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Critical Care",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal CNS-acting formulation for emergency/acute use."
  },
  {
    "id": "pnas036",
    "name": "Esketamine Nasal Spray",
    "generic": "Esketamine",
    "strength": "28 mg/device",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Neurology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal CNS-acting therapy."
  },
  {
    "id": "pnas037",
    "name": "Sumatriptan Nasal Spray",
    "generic": "Sumatriptan",
    "strength": "5 mg, 10 mg, 20 mg",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Neurology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal triptan for acute migraine relief."
  },
  {
    "id": "pnas038",
    "name": "Zolmitriptan Nasal Spray",
    "generic": "Zolmitriptan",
    "strength": "5 mg",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Neurology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal triptan for acute migraine relief."
  },
  {
    "id": "pnas039",
    "name": "Butorphanol Tartrate Nasal Spray",
    "generic": "Butorphanol Tartrate",
    "strength": "1 mg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Pain Management",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal opioid analgesic for pain management."
  },
  {
    "id": "pnas040",
    "name": "Nicotine Nasal Spray",
    "generic": "Nicotine",
    "strength": "10 mg/mL",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Nutraceuticals",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Nicotine replacement nasal spray for smoking cessation support."
  },
  {
    "id": "pnas041",
    "name": "Cyanocobalamin Nasal Spray",
    "generic": "Cyanocobalamin",
    "strength": "500 mcg/spray",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Nutraceuticals",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal vitamin B12 supplementation."
  },
  {
    "id": "pnas042",
    "name": "Testosterone Nasal Gel/Spray",
    "generic": "Testosterone Nasal Gel/Spray",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Endocrinology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal hormonal therapy."
  },
  {
    "id": "pnas043",
    "name": "Oxytocin Nasal Spray",
    "generic": "Oxytocin",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Endocrinology",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Specialty intranasal peptide/hormone therapy."
  },
  {
    "id": "pnas044",
    "name": "Fentanyl Nasal Spray",
    "generic": "Fentanyl",
    "strength": "Various",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Pain Management",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Intranasal analgesic for pain management. (Controlled/restricted \u2014 subject to import licensing in destination market.)"
  },
  {
    "id": "pnas045",
    "name": "Lidocaine Nasal Spray",
    "generic": "Lidocaine",
    "strength": "4%, 10%",
    "form": "Nasal Spray",
    "category": "nasal-sprays",
    "segment": "Critical Care",
    "pack": "Nasal spray bottle with metered pump",
    "desc": "Topical intranasal local anaesthetic."
  }
];
